<template>
  <div class="login">
    <page-header />
    <page-prompt/>
    <section class="main">
      <h2>总决赛登录</h2>
      <ul class="form">
        <li>
          <span>
            <el-input v-model="mobile" placeholder="请填写手机号码" />
          </span>
        </li>
        <li>
          <span>
            <el-input v-model="password" placeholder="请输入密码" show-password />
          </span>
        </li>
      </ul>
      <el-button class="submit" type="primary" @click="onLogin">点击验证登录</el-button>
      <div class="btns">
        <router-link to="/forgetpwd">忘记密码</router-link>
      </div>
      <p class="prompt">浏览器使用建议：请使用谷歌、火狐或IE10以上的浏览器。</p>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PagePrompt from '@/components/PagePrompt'
import { login } from '@/service/api'

export default {
  name: 'PageLogin',
  components: {
    PageHeader,
    PagePrompt
  },
  data () {
    return {
      mobile: '',
      password: ''
    }
  },
  methods: {
    onLogin () {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile))) {
        this.$alert('手机号码填写错误!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (!this.password) {
        this.$alert('请填写密码!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (this.password.length < 6) {
        this.$alert('密码不能小于6位!', '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      login({
        mobile: this.mobile,
        password: this.password
      }).then(res => {
        loading.close()
        this.$router.push('/basic')
      }).catch(err => {
        loading.close()
        this.$message({
          message: err,
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
